import GridLayout from './GridLayout.vue';
import ViewHeader from '@/views/ViewHeader.vue';

export default function routesBuilder({ path, viewConfig, configIdentifier }) {
  let routes = [
    {
      path: `/${path}`,
      name: path,
      // meta: { type: 'View', viewConfig, baseRoute: true, configIdentifier, hideToolbar: viewConfig.hideToolbarExtension },
      meta: {
        type: 'View',
        viewConfig,
        baseRoute: true,
        configIdentifier,
        isRouterViewFixed: true,

        // that leads to a one row header on pages other than home
        // however this should be refactored, by using a different header for home screen
       // oneRowToolbar:false // path.length > 1,
      },
      title: viewConfig.title,
      components: { default: GridLayout, header: ViewHeader },
    },
  ];

  return routes;
}
